export const CACHE_SEARCH_RESULTS_FOR_SECONDS: number =
 2 * 60; // Cache search results from server. Defaults to 2 minutes;
